const CodeBlock = props => (
  <div className='markdown-body'>
    <pre>{props.children}</pre>
  </div>
)

export default CodeBlock

